export abstract class FsMapSearchServiceProvider {
}
